import { TOP_BANNER_PLACEHOLDER_IDS } from './components/TopBanner'

/** Query params for Weekly Admin Digest → /psima deep-link */
export const DASHBOARD_DEEP_LINK_PARAMS = {
  /** Top Banner remediation filter id (`behavioralRisk`, `awarenessCoverage`, …) */
  FILTER: 'filter',
  /** When `true`, clear the filter if the filtered cards response is empty */
  CLEAR_IF_EMPTY: 'clearIfEmpty',
}

const VALID_FILTER_IDS = new Set(Object.values(TOP_BANNER_PLACEHOLDER_IDS))

export const parseDashboardDeepLink = (search = window.location.search) => {
  const params = new URLSearchParams(search)
  const filter = params.get(DASHBOARD_DEEP_LINK_PARAMS.FILTER)
  const clearIfEmptyRaw = params.get(DASHBOARD_DEEP_LINK_PARAMS.CLEAR_IF_EMPTY)

  if (!filter || !VALID_FILTER_IDS.has(filter)) {
    return null
  }

  return {
    filter,
    clearIfEmpty: clearIfEmptyRaw === 'true',
  }
}

export const clearDashboardDeepLinkParams = () => {
  const url = new URL(window.location.href)
  let changed = false

  Object.values(DASHBOARD_DEEP_LINK_PARAMS).forEach((key) => {
    if (url.searchParams.has(key)) {
      url.searchParams.delete(key)
      changed = true
    }
  })

  if (changed) {
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`)
  }
}
